import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { invalidateAiListeningProfileData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'
import {
  BrandProfile,
  CreateBrandProfilePayload,
} from 'src/services/aiListeningApi/brandProfile.types'

interface UseCreateAiListeningProfileMutationParams {
  onError?: (error: AxiosError<AiListeningErrorEnvelope>) => void
  onSuccess?: (profile: BrandProfile) => void
}

// No toast: the create page answers with its own success / failure modal.
export const useCreateAiListeningProfileMutation = ({
  onError,
  onSuccess,
}: UseCreateAiListeningProfileMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateBrandProfilePayload) =>
      AiListeningBrandProfileApiService.createProfile(payload),
    onError,
    onSuccess: (profile) => {
      invalidateAiListeningProfileData(queryClient)
      onSuccess?.(profile)
    },
  })
}
